import React from "react";
import { FaSignOutAlt, FaUser } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Button, Flex } from "@chakra-ui/react";
import "./NavLinks.css";
import { logout, reset } from "../../features/auth/authSlice";
import { useDispatch } from "react-redux";
import { SHARED_ROUTES } from "../../config/routes";

const NavLinks = () => {
  const { user } = useAuthenticator((context) => [context.user]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSignOut = () => {
    //reset user
    dispatch(logout()).then(() => {
      dispatch(reset());
      navigate("/");
    });
  };

  return (
    <Flex as="nav" className="nav-links">
      {user ? (
        <>
          <Link to={SHARED_ROUTES.home}>
            <Button as="span" leftIcon={<FaUser />} variant="link" color="blackAlpha900">Home</Button>
          </Link>
          <Button leftIcon={<FaSignOutAlt />} onClick={handleSignOut} colorScheme="red" className="nav-links__log-out">
            Logout
          </Button>
        </>
      ) : (
        <></>
      )}
    </Flex>
  );
};

export default NavLinks;
